import { UPDATE_CART } from '../../constants/redux-events';

export const initialCartState = [];

const cart = (state = initialCartState, { type, payload }) => {
    return type === UPDATE_CART ? [...payload] : state;
};

export default cart;
